export const fadeIn = (delay = 0) => ({
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        type: 'spring',
        duration: 1.25,
        delay,
      },
    },
});
export const slideIn = ({
    delay = 0,
    direction = 'up',
    offset = 10,
  }) => {
    return {
      hidden: {
        y: direction === 'down' ? -offset : direction === 'up' ? offset : 0,
        x: direction === 'left' ? -offset : direction === 'right' ? offset : 0,
        opacity: 0,
      },
      show: {
        y: 0,
        x: 0,
        opacity: 1,
        transition: {
          type: 'spring',
          stiffness: 300,
          damping: 20,
          delay,
        },
      },
    };
  };
export const slideUp = ({
    delay = 0,
    duration = 1.25,
    offset = 20,
  } = {}) => ({
    hidden: {
      y: offset,
      opacity: 0,
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        delay,
        duration,
      },
    },
});

export const sectionVariants = slideUp({
    delay: 0.5,
    duration: 1.75,
    offset: 50,
});
  
export const getSectionAnimation = {
    variants: sectionVariants,
    initial: 'hidden',
    whileInView: 'show',
    viewport: { once: true },
};